
import ajaxUtil from '../../../pub/utils/ajaxUtil';
var {showMessage} = require('../../../pub/utils/promptUtil');

function createRefBasicModel(config, template) {

    var model = new Object();
    var currentTreeNode = null;
    var _searchParams = {};  //查询参数
    var _treeCondition = {}; //树条件
    var _listCondition = {}; //树条件

    model.ajax = ajaxUtil;

    model.setCurrentTreeNode=function(node){
    	currentTreeNode = node;
    }
    model.getCurrentTreeNode=function(){
    	return currentTreeNode;
    }
    model.getSearchParams = function(){
        return _searchParams;
    }
    model.setSearchParams = function(params){
        _searchParams = params;
    }
    model.getTreeCondition = function(){
        return _treeCondition;
    }
    model.setTreeCondition = function(params){
        _treeCondition = params;
    }

    model.getListCondition = function(){
        return _listCondition;
    }
    model.setListCondition = function(params){
        _listCondition = params;
    }

    model.showMessage = function(title,message,type,duration,offset){
        showMessage(title,message,type,duration,offset);
    };

    model.mergeJsonObject = function(jsonA, jsonB){
           
        var resultJsonObject={};
        for(var attr in jsonA){
            resultJsonObject[attr]=jsonA[attr];
        }
        for(var attr in jsonB){
            resultJsonObject[attr]=jsonB[attr];
        }

        return resultJsonObject;
    }

    return model;
}

export default createRefBasicModel;



// WEBPACK FOOTER //
// ./src/pub/components/baseRef/baseRefModel.js